// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BERelationship } from './BERelationship';
import { EnumMultiplicity } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 关联关系基类 实体类
 * 关联关系基类，定义关联关系
 */
export abstract class BaseAssociation extends BERelationship {
  /** 源实体多样性 : 源实体的多样性 */
  private _sourceMultiplicity: EnumMultiplicity;

  /** 设置：源实体多样性 */
  public get sourceMultiplicity() {
    return this._sourceMultiplicity;
  }

  /** 获取：源实体多样性 */
  public set sourceMultiplicity(value: EnumMultiplicity) {
    this._sourceMultiplicity = value;
  }

  /** 源实体名称 : 源实体在关系中的名称 */
  private _sourceName: string;

  /** 设置：源实体名称 */
  public get sourceName() {
    return this._sourceName;
  }

  /** 获取：源实体名称 */
  public set sourceName(value: string) {
    this._sourceName = value;
  }

  /** 源实体显示名称 : 源实体在关系中的显示名称 */
  private _sourceDisplayName: string;

  /** 设置：源实体显示名称 */
  public get sourceDisplayName() {
    return this._sourceDisplayName;
  }

  /** 获取：源实体显示名称 */
  public set sourceDisplayName(value: string) {
    this._sourceDisplayName = value;
  }

  /** 源是否可导航 : 源是否可导航，true则代表源可导航到目标，即源的设置可用 */
  private _sourceIsNavigation: boolean;

  /** 设置：源是否可导航 */
  public get sourceIsNavigation() {
    return this._sourceIsNavigation;
  }

  /** 获取：源是否可导航 */
  public set sourceIsNavigation(value: boolean) {
    this._sourceIsNavigation = value;
  }

  /** 目标实体多样性 : 目标实体多样性 */
  private _targetMultiplicity: EnumMultiplicity;

  /** 设置：目标实体多样性 */
  public get targetMultiplicity() {
    return this._targetMultiplicity;
  }

  /** 获取：目标实体多样性 */
  public set targetMultiplicity(value: EnumMultiplicity) {
    this._targetMultiplicity = value;
  }

  /** 目标实体名称 : 目标实体在关系中的名称 */
  private _targetName: string;

  /** 设置：目标实体名称 */
  public get targetName() {
    return this._targetName;
  }

  /** 获取：目标实体名称 */
  public set targetName(value: string) {
    this._targetName = value;
  }

  /** 目标实体显示名称 : 目标实体在关系中的显示名称 */
  private _targetDisplayName: string;

  /** 设置：目标实体显示名称 */
  public get targetDisplayName() {
    return this._targetDisplayName;
  }

  /** 获取：目标实体显示名称 */
  public set targetDisplayName(value: string) {
    this._targetDisplayName = value;
  }

  /** 目标是否可导航 : 目标是否可导航，true则代表目标可导航到源，即目标的设置可用 */
  private _targetIsNavigation: boolean;

  /** 设置：目标是否可导航 */
  public get targetIsNavigation() {
    return this._targetIsNavigation;
  }

  /** 获取：目标是否可导航 */
  public set targetIsNavigation(value: boolean) {
    this._targetIsNavigation = value;
  }

  /** 源分组名 : 源实体归属的属性分组名 */
  private _sourceGroupName: string;

  /** 设置：源分组名 */
  public get sourceGroupName() {
    return this._sourceGroupName;
  }

  /** 获取：源分组名 */
  public set sourceGroupName(value: string) {
    this._sourceGroupName = value;
  }

  /** 目标分组名 : 目标实体归属的属性分组名 */
  private _targetGroupName: string;

  /** 设置：目标分组名 */
  public get targetGroupName() {
    return this._targetGroupName;
  }

  /** 获取：目标分组名 */
  public set targetGroupName(value: string) {
    this._targetGroupName = value;
  }

  constructor() {
    super();
    this._sourceMultiplicity = EnumMultiplicity.ZeroMany;
    this._sourceName = '';
    this._sourceDisplayName = '';
    this._sourceIsNavigation = true;
    this._targetMultiplicity = EnumMultiplicity.ZeroOne;
    this._targetName = '';
    this._targetDisplayName = '';
    this._targetIsNavigation = true;
    this._sourceGroupName = '';
    this._targetGroupName = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseAssociation, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.sourceMultiplicity = element.sourceMultiplicity;
      this.sourceName = element.sourceName;
      this.sourceDisplayName = element.sourceDisplayName;
      this.sourceIsNavigation = element.sourceIsNavigation;
      this.targetMultiplicity = element.targetMultiplicity;
      this.targetName = element.targetName;
      this.targetDisplayName = element.targetDisplayName;
      this.targetIsNavigation = element.targetIsNavigation;
      this.sourceGroupName = element.sourceGroupName;
      this.targetGroupName = element.targetGroupName;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.sourceMultiplicity = json.SourceMultiplicity as EnumMultiplicity;
    this.sourceName = json.SourceName;
    this.sourceDisplayName = json.SourceDisplayName;
    this.sourceIsNavigation = json.SourceIsNavigation;
    this.targetMultiplicity = json.TargetMultiplicity as EnumMultiplicity;
    this.targetName = json.TargetName;
    this.targetDisplayName = json.TargetDisplayName;
    this.targetIsNavigation = json.TargetIsNavigation;
    this.sourceGroupName = json.SourceGroupName;
    this.targetGroupName = json.TargetGroupName;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.SourceMultiplicity = this.sourceMultiplicity;
    json.SourceName = this.sourceName;
    json.SourceDisplayName = this.sourceDisplayName;
    json.SourceIsNavigation = this.sourceIsNavigation;
    json.TargetMultiplicity = this.targetMultiplicity;
    json.TargetName = this.targetName;
    json.TargetDisplayName = this.targetDisplayName;
    json.TargetIsNavigation = this.targetIsNavigation;
    json.SourceGroupName = this.sourceGroupName;
    json.TargetGroupName = this.targetGroupName;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('源设置', 'sourceMultiplicity', '源实体多样性', EnumDataType.Reference, this.sourceMultiplicity, true, '源实体的多样性', 'EnumMultiplicity', 'PGRowEnumValue');
    context.addRow('源设置', 'sourceName', '源实体名称', EnumDataType.String, this.sourceName, true, '源实体在关系中的名称', '', '');
    context.addRow('源设置', 'sourceDisplayName', '源实体显示名称', EnumDataType.String, this.sourceDisplayName, true, '源实体在关系中的显示名称', '', '');
    context.addRow('目标设置', 'targetMultiplicity', '目标实体多样性', EnumDataType.Reference, this.targetMultiplicity, true, '目标实体多样性', 'EnumMultiplicity', 'PGRowEnumValue');
    context.addRow('目标设置', 'targetName', '目标实体名称', EnumDataType.String, this.targetName, true, '目标实体在关系中的名称', '', '');
    context.addRow('目标设置', 'targetDisplayName', '目标实体显示名称', EnumDataType.String, this.targetDisplayName, true, '目标实体在关系中的显示名称', '', '');
    context.addRow('源设置', 'sourceGroupName', '源分组名', EnumDataType.String, this.sourceGroupName, true, '源实体归属的属性分组名', '', '');
    context.addRow('目标设置', 'targetGroupName', '目标分组名', EnumDataType.String, this.targetGroupName, true, '目标实体归属的属性分组名', '', '');
  }
}
